import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'

const module = 'statuses'
let doc = {
  list: {
    name: 'Statut',
    headers: [
      { label: 'Nom', value: 'name' },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
    ],
  },

  form: {},

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}

export default crudmaker(module, apiClient, doc)
